export default [
  {
    path: "/reset-certification",
    name: "ResetCertification",
    component: () => import("./views/ResetCertificationView.vue"),
    props: (route) => {
      const props = {
        activationKey: route.query["key"]
      };
      return props;
    }
   },

];
